import React, { Component } from "react"
import "../css/SplashScreen.css"

//material ui
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import Paper from "@material-ui/core/Paper"
import CircularProgress from "@material-ui/core/CircularProgress"

const styles = theme => ({
	main: {
		width: "100vh",
		display: "block", // Fix IE 11 issue.
		marginTop: 260,
		marginBottom: "100vh",
		marginLeft: theme.spacing.unit * 3,
		marginRight: theme.spacing.unit * 3,
		[theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
			width: 400,
			marginLeft: "auto",
			marginRight: "auto"
		}
	},
	paper: {
		marginTop: theme.spacing.unit * 8,
		boxShadow: "none",
		display: "flex",
		flexGrow: 1,
		flexDirection: "column",
		alignItems: "center",
		padding: `${theme.spacing.unit * 0}px ${theme.spacing.unit * 0}px ${theme
			.spacing.unit * 0}px`
	},
	linearProgress: {
		width: "100%"
	}
})

class Page extends Component {
	render() {
		const { classes } = this.props
		return (
			<div className="banner_CircularProgress">
				<div className="banner_inner d-flex align-items-center">
					<div className={classes.main}>
						<Paper className={classes.paper}>
							<CircularProgress style={{ zIndex: 1 }} />
						</Paper>
					</div>
				</div>
			</div>
		)
	}
}

Page.propTypes = {
	title: PropTypes.string
}
Page.defaultProps = {
	title: "Loading EU Project"
}
export default withStyles(styles, { withTheme: true })(Page)
